import React, { useState, useEffect } from "react";
import {
  PlusCircleIcon,
  AdjustmentsVerticalIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useGetTemplatesQuery,
  useUpdateTemplatesMutation,
  useDeleteTemplatesMutation,
} from "../../../../../store/templates";
import DeleteSmsModal from "../../../../modal/DeleteSmsModal";
import ToggleButton from "../../../../commons/ToggleButton";
import { toast } from "react-toastify";
import { formatQuillResponse } from "../../../../../utilities/utils";
import Loader from "../../../../commons/Loader";
import { useGetUserDetailsQuery } from "../../../../../store/admin/professionalUserInfo";


const ProfessionalEmailTemplate = ({ isMobile }) => {
  const navigate = useNavigate();
  const [updatedEmailTemplates, setUpdatedEmailTemplates] = useState();
  const [isToggleEnabled, setIsToggleEnabled] = useState(false);
  const [showDeleteEmailModal, setShowDeleteEmailModal] = useState(false);
  const [showRestoreDefaultModal, setShowRestoreDefaultModal] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");

  const location = useLocation();

  const { professionalId } = location?.state ?? {};

     const {
        data: professionalInfoDetail,
        refetch: refetchProfessionalInfoDetail,
      } = useGetUserDetailsQuery(professionalId);
  const { data: templatesData, refetch: templateUpdateData } =
    useGetTemplatesQuery();

  const [
    updateEmailTemplate,
    {
      isSuccess: updateEmailTemplateSuccess,
      isLoading: updateEmailTemplateLoader,
      isError: updateEmailTemplateError,
      data: updateEmailTemplateData,
    },
  ] = useUpdateTemplatesMutation();

  const [
    deleteEmailTemplate,
    {
      isSuccess: deleteEmailSuccess,
      isLoading: deleteEmailLoader,
      data: deleteEmailTemplateData,
    },
  ] = useDeleteTemplatesMutation();

  useEffect(() => {
    if (location?.state?.updateEmailQuery) {
      // templateUpdateData();
    }
  }, [location?.state]);

  useEffect(() => {
      if(professionalInfoDetail?.data?.messageTemplates.length)
      {
        const enabledSmsTemplate = [];
        const filteredSmsTemplate = professionalInfoDetail?.data?.messageTemplates?.filter((temp) =>
          temp.type.includes("email")
        );
        filteredSmsTemplate.forEach((element) => {
          if (element.type === "initial_email") {
            enabledSmsTemplate.unshift(element);
          } else {
            enabledSmsTemplate.push(element);
          }
        });
        setUpdatedEmailTemplates(enabledSmsTemplate);
        setIsToggleEnabled(!!enabledSmsTemplate[0].automatically_send_on_match);
      }
  
    }, [professionalInfoDetail?.data?.messageTemplates]);

  useEffect(() => {
    if (updateEmailTemplateSuccess && !updateEmailTemplateLoader) {
      toast.success(updateEmailTemplateData.message);
    }
  }, [updateEmailTemplateSuccess]);

  useEffect(() => {
    if (deleteEmailTemplateData && !deleteEmailLoader) {
      setShowDeleteEmailModal(false);
      setShowRestoreDefaultModal(false);
      toast.success("Message template restore successfully");
    }
  }, [deleteEmailTemplateData]);

  const handleClose = () => {
    setShowRestoreDefaultModal(false);
    setShowDeleteEmailModal(false);
  };

  const handleEmailDelete = () => {
    deleteEmailTemplate(selectedTemplateId);
  };

  const handleEditChange = (
    mode,
    title,
    subject,
    content,
    photoSignature,
    id
  ) => {
    navigate(`/admin-dashboard/professional-profile/email-template/${mode}`, {
      state: {
        mode: "edit",
        name: title,
        subject: subject,
        content: content,
        add_photo_to_signature: photoSignature,
        templateId: id,
        professionalId: location?.state?.professionalId
      },
    });
  };

  const handleToggle = (id, value) => {
    if (value == 1) {
      updateEmailTemplate({
        id: id,
        automatically_send_on_match: 0,
        _method: "PUT",
      });
    } else {
      updateEmailTemplate({
        id: id,
        automatically_send_on_match: 1,
        _method: "PUT",
      });
    }
    setIsToggleEnabled((prev) => !prev);
  };

  return updatedEmailTemplates && updatedEmailTemplates.length > 0 ? (
    <>
      <div>
        <div className="flex justify-between mb-[30px] gap-5">
          <div className="w-[calc(100%-68px)]">
            {!isMobile && (
              <h4 className="text-[22px] font-bold leading-[160%] text-customGray mb-1">
                InstantEngage™ Email Templates
              </h4>
            )}
            <p className="text-base font-medium leading-[160%] text-[#485868]">
              Respond to customers quickly with custom Email templates.
            </p>
          </div>
          <div className="tooltip-icon relative inset-y-0 right-0 flex items-center h-6 my-auto cursor-pointer">
            {/* <PlusCircleIcon
              style={{
                pointerEvents:
                  updatedEmailTemplates && updatedEmailTemplates.length === 4
                    ? "none"
                    : "auto",
              }}
              className={`w-12 h-12 p-3 ${
                updatedEmailTemplates && updatedEmailTemplates.length === 4
                  ? "bg-[#B7C9DA]"
                  : "bg-primary"
              }  text-[#ffffff] rounded-[10px] cursor-pointer`}
              // className="w-12 h-12 p-3 bg-primary text-white rounded-[10px] cursor-pointer"
              onClick={handleEmailEditor}
            /> */}
            {updatedEmailTemplates && updatedEmailTemplates.length === 4 && (
              <div className="tooltip absolute -right-2 -bottom-[80px] bg-[#191549] rounded-md p-[10px] w-[312px] z-[2] invisible">
                <div className="w-4 h-4 rotate-45 rounded-tl-[4px] bg-[#191549] -mt-4 mr-[14px] ml-auto"></div>
                <p className="text-xs font-medium leading-[160%] text-[#F1F4F6]">
                  You can only have two additional Email text messages.
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
          {updatedEmailTemplates &&
            updatedEmailTemplates.map((temp, index) => (
              <div key={index}>
                <div className="p-5 pt-6 border border-solid border-[#EBEFF3] rounded-md bg-white">
                  <h5 className="text-base font-bold leading-[160%] text-customGray mb-[10px]">
                    {temp.name}
                  </h5>
                  <p className="text-sm leading-[170%] text-[#485868] mb-[18px] max-h-[120px] overflow-y-auto scroller">
                    {formatQuillResponse(temp.content)}
                  </p>
                  <div
                    className={`pt-[18px] border-t border-solid border-[#EBEFF3] flex xl:items-center justify-between ${
                      index > 0
                        ? "gap-[30px] flex-row"
                        : "justify-between gap-2 flex-col xl:flex-row"
                    }`}
                  >
                    <button
                      className="text-sm font-bold leading-[160%] text-primary flex items-center gap-[6px]"
                      onClick={() =>
                        handleEditChange(
                          "edit",
                          temp.name,
                          temp.subject,
                          temp.content,
                          temp.add_photo_to_signature,
                          temp.id
                        )
                      }
                    >
                      <AdjustmentsVerticalIcon className="w-5 h-5 text-primary" />
                      Edit Message
                    </button>
                    <div className="flex items-center xl:items-end 4xl:items-center gap-2 4xl:gap-5 justify-between md:justify-between xl:justify-end 4xl:justify-between xl:flex-col-reverse 4xl:flex-row">
                      <button
                        className="text-sm font-bold leading-[160%] text-primary flex items-center gap-[6px]"
                        // onClick={() => deleteEmailTemplate(temp.id)}
                        onClick={() => {
                          setShowRestoreDefaultModal(true);
                          setSelectedTemplateId(temp.id);
                        }}
                      >
                        Restore Default
                      </button>
                      {index === 0 && (
                        <div className="flex items-center">
                          <span className="text-xs font-bold leading-[160%] text-[#485868] max-w-[150px] mr-[6px]">
                            Enable for Sending
                          </span>
                          <ToggleButton
                            isEnabled={isToggleEnabled}
                            onToggle={() =>
                              handleToggle(
                                temp.id,
                                temp.automatically_send_on_match
                              )
                            }
                          />
                        </div>
                      )}
                    </div>
                    {index > 1 && (
                      <button
                        className="text-sm font-bold leading-[160%] text-[#485868] flex items-center gap-[6px]"
                        onClick={() => {
                          setShowDeleteEmailModal(true);
                          setSelectedTemplateId(temp.id);
                        }}
                      >
                        <TrashIcon className="w-5 h-5 text-[#485868]" />
                        Delete
                      </button>
                    )}
                  </div>
                </div>
                {index === 0 && (
                  <div className="py-5 px-[22px] bg-[#f2f2f2] border-solid border-[#f1f4f6] rounded-md -mt-1 flex gap-1.5">
                    <InformationCircleIcon className="w-6 h-6 text-[#485868]" />
                    <p className="text-sm leading-[170%] text-[#485868] w-[calc(100%-30px)]">
                      This email is sent immediately upon receiving a client
                      lead into your account, so you can automatically get in
                      touch right away.
                    </p>
                  </div>
                )}
                {index === 1 && (
                  <div className="py-5 px-[22px] bg-[#f2f2f2] border-solid border-[#f1f4f6] rounded-md -mt-1 flex gap-1.5">
                    <InformationCircleIcon className="w-6 h-6 text-[#485868]" />
                    <p className="text-sm leading-[170%] text-[#485868] w-[calc(100%-30px)]">
                      This email can be sent to your matches 24 hours after the
                      initial email is sent, and must be triggered manually from
                      your dashboards Matches menu.
                    </p>
                  </div>
                )}
              </div>
            ))}
        </div>
        <DeleteSmsModal
          isOpen={showDeleteEmailModal}
          handleClose={handleClose}
          handleDelete={handleEmailDelete}
          deleteLoader={deleteEmailLoader}
          text="Do you really want to delete this email template?"
        />
        <DeleteSmsModal
          isOpen={showRestoreDefaultModal}
          handleClose={handleClose}
          handleDelete={() => {
            deleteEmailTemplate(selectedTemplateId);
            setSelectedTemplateId("");
          }}
          deleteLoader={deleteEmailLoader}
          text="Do you really want to restore default email template?"
        />
      </div>
    </>
  ) : (
    <Loader isLoading={true} />
  );
};

export default ProfessionalEmailTemplate;